import { ZtTableHeaderType, ZtTableRow } from './zt-table.model';

export const filterString = <T extends ZtTableRow>(
    key: string,
    word: string
): ((row: T) => boolean) => {
    return function (data: T): boolean {
        return (data[key as keyof T] as unknown as string)
            .toString()
            .toLowerCase()
            .includes(word.toLowerCase());
    };
};

export const filterStringVariants = <T extends ZtTableRow>(
    key: string,
    words: string[]
): ((row: T) => boolean) => {
    return function (data: T): boolean {
        return words.indexOf(data[key as keyof T] as unknown as string) > -1;
    };
};

export const filterDate = <T extends ZtTableRow>(
    key: string,
    date: Date
): ((row: T) => boolean) => {
    return function (data: T): boolean {
        const rowDate = data[key as keyof T] as unknown as Date;
        return (
            date.getFullYear() == rowDate.getFullYear() &&
            date.getMonth() == rowDate.getMonth() &&
            date.getDate() == rowDate.getDate()
        );
    };
};

export const filterFunctionMap = new Map<ZtTableHeaderType, Function>([
    [ZtTableHeaderType.STRING, filterString],
    [ZtTableHeaderType.STRING_VARIANTS, filterStringVariants],
    [ZtTableHeaderType.DATE, filterDate],
]);
